import { render, staticRenderFns } from "./Promotion_details_group.vue?vue&type=template&id=1c6a1e88&scoped=true&"
import script from "./Promotion_details_group.vue?vue&type=script&lang=js&"
export * from "./Promotion_details_group.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_details_group.vue?vue&type=style&index=0&id=1c6a1e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a1e88",
  null
  
)

export default component.exports